'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isThisYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isThisYear.js
// module id = 557
// module chunks = 0